import Helpers from "../commons/helpers";
import useStrings from "./useStrings";

import { useState } from "react";
import { ICodename, IMultiLanguageContent } from "../commons/interfaces";
import { CodeNameCommon, Status } from "../constants/enums";
import { getAllDataCodename } from "../containers/codename/list";
import { commonGetAllDataRole } from "../containers/role/list";
import { useCommonComponentContext } from "../providers/CommonComponentProvider";
import OrganizationService from "../services/identity/organization.service";

//
export interface IUserRole {
    id: string;
    userId: string;
    groupId: string;
    organizationId: string;
    title: string;
    roleCode: string;
    roleId: string;
    roleLevel: number;
    roleName: string;
    roleType: number;
    serviceCode: string;
    serviceName: string;
    tenantCode: string;
    tenantName: string;
    startTime: string;
    endTime: string;
    status: number;
    activeStatus: number;
    createTime: string;
    createUser: string;
    updateTime: string;
    updateUser: string;
}

export interface IOrgProfile {
    id: string;
    gene: string;
    location: any;
    addressId: string;
    organizationId: string;
    name: IMultiLanguageContent;
    description: IMultiLanguageContent;
    type: number;
    timeZone: any;
    email: string;
    website: string;
    faxNumber: string;
    taxNumber: string;
    phoneNumber: string;
    groupId: string;
    groupCode: string;
    groupStatus: number;
    parentGroup: string;
    parentGroupName: IMultiLanguageContent;
    userNumber: number;
    childNumber: number;

    status: number;
    createTime: string;
    createUser: string;
    updateTime: string;
    updateUser: string;
}

export interface IOrgUserProfile {
    id: string;
    userId: string;
    userType: number;
    userCode: string;
    isOwner: boolean;
    avatarId: string;
    avatarUrl: string;
    idCardNo: string;
    idCardIssuedDate: string;
    idCardIssuedPlace: string;
    lastName: string;
    firstName: string;
    email: string;
    gender: number;
    phoneNumber: string;
    dateOfBirth: string;
    employmentDate: string;
    terminationtDate: string;
    socialInsuranceCode: string;
    extraInformation: string;
    status: number;
    activeStatus?: number;
    organizationId: string;
    invitation?: any;
    groups?: {
        id: string;
        userId: string;
        userTitle: string;
        name: IMultiLanguageContent;
    }[];
    userRoles?: IUserRole[];
    createTime?: string;
    createUser?: string;
    updateTime?: string;
    updateUser?: string;
}

export interface IOrganization {
    id: string;
    isOwner: boolean;
    isAdmin: boolean;
    tenantCode: string;
    organizationCode: string;
    userNumber: number;
    groupNumber: number;
    type: number;
    gene: string;
    name: IMultiLanguageContent;
    email: string;
    taxNumber: string;
    faxNumber: string;
    phoneNumber: string;
    logoId: string;
    logoUrl: string;
    website: string;
    addressId: string;
    description: IMultiLanguageContent;
    organizationProfiles: IOrgProfile[];
    organizationUserProfiles: IOrgUserProfile[];

    status: number;
    searchText: string;
    createTime: string;
    createUser: string;
    updateTime: string;
    updateUser: string;
}

export interface IDataDetailOrg {
    id?: string;
    isOwner?: boolean;
    isAdmin?: boolean;

    gene?: string;
    email?: string;
    logoId?: string;
    logoUrl?: string;
    website?: string;
    taxNumber?: string;
    faxNumber?: string;
    addressId?: string;
    phoneNumber?: string;
    userNumber?: number;
    groupNumber?: number;
    organizationCode?: string;
    name?: IMultiLanguageContent;
    description?: IMultiLanguageContent;

    owner?: string;
    status?: number;
}
//

const useContainerOrganization = () => {
    const strings = useStrings();

    const { language, clientId, tenantCode, serviceCode, listMultiLanguage, onError, onSuccess, onShowLoading, onHideLoading } =
        useCommonComponentContext();

    const [isOnChange, setIsOnChange] = useState<boolean>(false);
    const [valMultilanguage, setValMultiLanguage] = useState<string>("");

    const [dataOwnerOrg, setDataOwnerOrg] = useState<IOrgUserProfile | undefined>(undefined);
    const [errorDetailOrg, setErrorDetailOrg] = useState<{ [key in keyof IDataDetailOrg]?: string }>({});
    const [dataDetailOrg, setDataDetailOrg] = useState<IDataDetailOrg>({
        isAdmin: false,
        isOwner: false,
        name: { value: { vi: "", en: "" } },
        description: { value: { vi: "", en: "" } },
    });

    const [dataRoles, setDataRoles] = useState<ICodename[]>([]);
    const [dataGroups, setDataGroups] = useState<ICodename[]>([]);
    const [dataUserTitle, setDataUserTitle] = useState<ICodename[]>([]);

    const [dataGroupByOrg, setDataGroupByOrg] = useState<IOrgProfile[]>([]);
    const [dataStaffByOrg, setDataStaffByOrg] = useState<IOrgUserProfile[]>([]);
    const [idGroupDefaultByOrg, setidGroupDefaultByOrg] = useState<string>("");

    const getDetailOrganization = async (id: string) => {
        try {
            onShowLoading();

            const resultDetail: IOrganization = await OrganizationService.getDetail({ id: id, clientId: clientId });

            let ownerProfile: IOrgUserProfile | undefined = undefined;
            let organizationProfile: IOrgProfile | undefined = undefined;

            let newIdGroupDefault: string = "";
            let newGroupsTemp: ICodename[] = [];
            let newGroupByOrg: IOrgProfile[] = [];
            let newStaffByOrg: IOrgUserProfile[] = [];

            [...resultDetail?.organizationUserProfiles || []].forEach((item: IOrgUserProfile) => {
                if (item.isOwner === true &&
                    (item.status === Status.Active ||
                        item.status === Status.PendingInvitation)) {
                    ownerProfile = item;
                }
                newStaffByOrg.push(item);
            });

            [...(resultDetail?.organizationProfiles || [])].forEach((item: IOrgProfile) => {
                if (item.parentGroup === "0") {
                    organizationProfile = item;
                }
                if (item.type === 0) {
                    newIdGroupDefault = item.groupId;
                } else {
                    newGroupByOrg.push(item);

                    if (item.groupStatus === Status.Active) {
                        newGroupsTemp.push({
                            code: item.groupId,
                            name: Helpers.renderValueByLanguage({ data: item.name, currentLanguage: language }),
                            detail: {
                                type: item.type,
                                parentGroup: item.parentGroup,
                            },
                        });
                    }
                }
            });

            const newDataDetail: IDataDetailOrg = {
                id: id,
                isAdmin: resultDetail?.isAdmin || false,
                isOwner: resultDetail?.isOwner || false,

                name: resultDetail?.name,
                gene: resultDetail?.gene,
                logoId: resultDetail?.logoId,
                logoUrl: resultDetail?.logoUrl,
                email: organizationProfile?.email,
                website: organizationProfile?.website,
                addressId: organizationProfile?.addressId,
                taxNumber: organizationProfile?.taxNumber,
                faxNumber: organizationProfile?.faxNumber,
                phoneNumber: organizationProfile?.phoneNumber,
                description: resultDetail?.description,

                userNumber: resultDetail?.userNumber,
                groupNumber: resultDetail?.groupNumber,
                organizationCode: resultDetail?.organizationCode,
                status: resultDetail?.status,
            };

            if (newGroupByOrg.length > 0) {
                let dataGroupsBySort: { gene: string }[] = Array.from(newGroupByOrg);
                dataGroupsBySort.sort(({ gene: g }, { gene: k }) =>
                    g.length === k.length ? g.localeCompare(k) : g.includes(k) ? 1 : k.includes(g) ? -1 : g.localeCompare(k)
                );
            }

            setDataGroups(newGroupsTemp);
            setDataOwnerOrg(ownerProfile);
            setDataDetailOrg(newDataDetail);
            setDataStaffByOrg(newStaffByOrg);
            setDataGroupByOrg(newGroupByOrg);
            setidGroupDefaultByOrg(newIdGroupDefault);
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    const getDataOrther = async (organizationId: string) => {
        try {
            let dataRoleTemp: ICodename[] = await commonGetAllDataRole({
                status: Status.Active,
                organizationId: organizationId,
            });
            setDataRoles(dataRoleTemp);

            const resultGetAllCodeName = await getAllDataCodename({
                serviceCode: serviceCode,
                organizationId: organizationId,
                group: [CodeNameCommon.USER_TITLE],
            });

            let dataUserTitleTemp = resultGetAllCodeName.get(CodeNameCommon.USER_TITLE) || [];
            setDataUserTitle(dataUserTitleTemp);
        } catch (error) { }
    };

    const handleChangeOwner = (lable?: string) => {
        Helpers.showConfirmAlert(
            strings.format(strings.Organization.CONFIRM_CHANGE_OWNER, lable || strings.Common.ORGANIZATION),
            () => {
                setDataOwnerOrg(undefined);

                setDataDetailOrg((prev) => ({
                    ...prev,
                    owner: undefined,
                }));

                setErrorDetailOrg((prev) => ({
                    ...prev,
                    owner: undefined,
                }));
            },
            () => { }
        );
    };

    const handleChangeLanguage = (value: string) => {
        setValMultiLanguage(value);

        setDataDetailOrg({
            ...dataDetailOrg,
            name: Helpers.getDataMultiLanguage({
                data: dataDetailOrg.name,
                currentLanguage: language,
                listLanguage: listMultiLanguage,
            }),
            description: Helpers.getDataMultiLanguage({
                data: dataDetailOrg.description,
                currentLanguage: language,
                listLanguage: listMultiLanguage,
            }),
        });

        setErrorDetailOrg((prev) => ({
            ...prev,
            name: undefined,
            description: undefined,
        }));
    };

    const handleChangeValueDataDetailOrganization = async (newValue: any, key: string, isMultiLang?: boolean) => {
        setDataDetailOrg((prev) => {
            let dataTemp: any = { ...prev };

            if (isMultiLang) {
                dataTemp[key] = {
                    ...dataTemp[key],
                    value: {
                        ...dataTemp[key]?.value,
                        [valMultilanguage]: newValue,
                    },
                };
            } else {
                if (key === "logo") {
                    dataTemp["logoId"] = newValue?.logoId;
                    dataTemp["logoUrl"] = newValue?.logoUrl;
                } else {
                    dataTemp[key] = newValue;
                }
            }

            return dataTemp;
        });

        setErrorDetailOrg((prev) => {
            let errTemp: any = { ...prev };

            if (key === "logo") {
                errTemp["logoId"] = undefined;
                errTemp["logoUrl"] = undefined;
            } else {
                errTemp[key] = undefined;
            }

            return errTemp;
        });

        if (!isOnChange) {
            setIsOnChange(true);
        }
    };

    const onCheckValidateDataDetailOrganization = () => {
        let isValid = true;
        let newError: any = { ...errorDetailOrg };

        if (Helpers.isNullOrEmpty(dataDetailOrg?.name?.value?.[language])) {
            isValid = false;
            newError["name"] = strings.Common.REQUIRED;
        }
        if (!Helpers.isNullOrEmpty(dataDetailOrg?.phoneNumber) && dataDetailOrg?.phoneNumber?.length < 8) {
            isValid = false;
            newError["phoneNumber"] = strings.Common.WRONG_PHONE_NUMBER;
        }

        if (!Helpers.isNullOrEmpty(dataDetailOrg?.owner) && !Helpers.isValidEmail(dataDetailOrg?.owner)) {
            isValid = false;
            newError["owner"] = strings.Common.EMAIL_ADDRESS;
        }

        if (!isValid) {
            setErrorDetailOrg(newError);
        }

        return isValid;
    };

    const onCreateUpdateOrganization = async ({
        newLableOrg,
        onCallBack,
    }: {
        newLableOrg: string;
        onCallBack: (data: { id: string; code: string; gene: string; name: IMultiLanguageContent }) => void;
    }) => {
        if (!onCheckValidateDataDetailOrganization()) {
            return;
        } else {
            try {
                onShowLoading();

                let newDataSubmit: any = {
                    type: 0,
                    clientId: clientId,
                    tenantCode: tenantCode,
                    serviceCodes: [serviceCode],

                    isActive: Status.Active,
                    logoId: dataDetailOrg.logoId,
                    logoUrl: dataDetailOrg.logoUrl,
                    website: dataDetailOrg.website,
                    faxNumber: dataDetailOrg.faxNumber,
                    taxNumber: dataDetailOrg.taxNumber,
                    addressId: dataDetailOrg.addressId,
                    phoneNumber: dataDetailOrg.phoneNumber,
                    email: dataDetailOrg.email || undefined,
                    name: Helpers.getDataMultiLanguage({
                        data: dataDetailOrg.name,
                        currentLanguage: language,
                        listLanguage: listMultiLanguage,
                    }) || { value: { [language]: "" } },
                    description: Helpers.getDataMultiLanguage({
                        data: dataDetailOrg.description,
                        currentLanguage: language,
                        listLanguage: listMultiLanguage,
                    }) || { value: { [language]: "" } },

                    owner: dataDetailOrg?.owner,
                };
                if (Helpers.isNullOrEmpty(dataDetailOrg?.id)) {
                    const result = await OrganizationService.create(newDataSubmit);

                    setIsOnChange(false);

                    onCallBack({
                        id: result?.organizationId,
                        name: result.organization?.name,
                        gene: result?.organization?.gene,
                        code: result?.organization?.organizationCode,
                    });

                    onSuccess(strings.format(strings.Organization.CREATE_SUCCESS, newLableOrg));
                } else {
                    newDataSubmit = {
                        ...newDataSubmit,
                        id: dataDetailOrg?.id,
                        organizationUserProfile: Helpers.isNullOrEmpty(dataOwnerOrg?.id)
                            ? undefined
                            : {
                                id: dataOwnerOrg?.id,
                                lastName: dataOwnerOrg?.lastName,
                                firstName: dataOwnerOrg?.firstName,
                            },
                    };

                    await OrganizationService.update(newDataSubmit);

                    setIsOnChange(false);

                    onCallBack({
                        id: dataDetailOrg?.id,
                        name: dataDetailOrg?.name,
                        gene: dataDetailOrg?.gene,
                        code: dataDetailOrg?.organizationCode,
                    });

                    onSuccess(strings.format(strings.Organization.UPDATE_SUCCESS, newLableOrg));
                }
            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        }
    };

    const handleChangeStatus = ({ row, onCallBack }: { row: any; onCallBack?: () => void }) => {
        const messageAlert =
            Number(row.status) === Status.Active ? strings.Organization.CONFIRM_IN_ACTIVE_STATUS : strings.Organization.CONFIRM_ACTIVE_STATUS;

        Helpers.showConfirmAlert(messageAlert, async () => {
            try {
                onShowLoading();

                const result = await OrganizationService.updateStatus({
                    allService: false,
                    clientId: clientId,
                    organizationId: row.id,
                    isActive: Number(row.status) === Status.Active ? false : true,
                });

                if (result.statusCode === 200) {
                    onCallBack && onCallBack();

                    const messageSuccess =
                        Number(row.status) === Status.Active
                            ? strings.Organization.IN_ACTIVE_STATUS_SUCCESS
                            : strings.Organization.ACTIVE_STATUS_SUCCESS;

                    onSuccess(messageSuccess);
                }
            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        });
    };

    return {
        dataRoles,
        dataGroups,
        dataUserTitle,
        dataGroupByOrg,
        dataStaffByOrg,
        idGroupDefaultByOrg,

        isOnChange,
        setIsOnChange,
        dataOwnerOrg,
        setDataOwnerOrg,
        dataDetailOrg,
        setDataDetailOrg,
        errorDetailOrg,
        setErrorDetailOrg,
        valMultilanguage,
        setValMultiLanguage,

        handleChangeLanguage,
        handleChangeValueDataDetailOrganization,

        getDataOrther,
        getDetailOrganization,

        handleChangeOwner,
        handleChangeStatus,
        onCreateUpdateOrganization,
    };
};

export default useContainerOrganization;
